class AppUsageService {
    constructor($q, commerceService) {
        this.$q = $q;
        this.commerceService = commerceService;
    }
}

export default AppUsageService;
